import {ColorSystemOptions, createTheme} from "@mui/material/styles";

declare module "@mui/material/Paper" {
  interface PaperPropsVariantOverrides {
    feature: true;
  }
}

const lightTheme: ColorSystemOptions = {
  palette: {
    primary: {
      light: "#F8FAFF",
      main: "#E7EDFF",
      dark: "#146AB5",
      contrastText: "#464255",
    },
    secondary: {
      light: "#F7F8F8",
      main: "#E6E6E6",
      dark: "#444559",
      contrastText: "#5A5A5A",
    },
    text: {
      primary: "#464255",
    },
    success: {
      light: "#EAF6ED",
      main: "#019A51",
    },
    warning: {
      light: "#FFFADC",
      main: "#FFB800",
    },
    error: {
      light: "#FDF4F3",
      main: "#EB5757",
    },
  },
};

export const dropShadowEl1Theme = "0px 2px 8px rgba(0, 0, 0, 0.05)"; // old "6px 6px 12px 0px #C7C7C740"
export const dropShadowEl2Theme = "0px 4px 12px rgba(0, 0, 0, 0.08)";
export const strokeTheme = "1px solid #D0D5DD";
export const fontFamilyPrimaryTheme = '"Hanken Grotesk", serif';
export const fontFamilySecondaryTheme = '"Roboto Condensed", sans-serif';
export const fontFamilyTertiaryTheme = '"Inter", sans-serif';

export const BORDER_RADIUS_INNER = "8px";
export const BORDER_RADIUS_OUTER = "12px";

const theme = createTheme({
  colorSchemes: {
    light: lightTheme,
    dark: false,
  },
  typography: {
    fontFamily: fontFamilyPrimaryTheme,
  },
  breakpoints: {
    values: {
      xs: 0, // Phones (portrait)
      sm: 600, // Phones (landscape), small tablets
      md: 900, // Tablets (portrait), small laptops
      lg: 1200, // Desktops and larger tablets (landscape)
      xl: 1564, // Large desktops / ultrawide monitors
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "#000",
              borderWidth: "1px",
            },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000",
            borderWidth: "1px",
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          boxShadow: dropShadowEl1Theme,
        },
      },
      variants: [
        {
          props: {variant: "feature"},
          style: {
            backgroundColor: "white",
            borderRadius: BORDER_RADIUS_OUTER,
          },
        },
      ],
    },
    MuiButton: {
      defaultProps: {
        style: {
          textTransform: "none",
        },
      },
      variants: [
        {
          props: {variant: "contained"},
          style: ({theme}) => ({
            borderRadius: BORDER_RADIUS_INNER,
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.common.white,
          }),
        },
        {
          props: {variant: "outlined"},
          style: ({theme}) => ({
            borderRadius: BORDER_RADIUS_INNER,
            color: theme.palette.primary.contrastText,
            border: strokeTheme,
          }),
        },
        {
          props: {variant: "text"},
          style: ({theme}) => ({
            borderRadius: BORDER_RADIUS_INNER,
            color: theme.palette.primary.dark,
          }),
        },
      ],
    },

    MuiChip: {
      styleOverrides: {
        deleteIcon: {
          color: "#444559",
          "&:hover": {
            color: "#2f2f3b",
          },
        },
      },
    },
  },
});

export default theme;
